export default __webpack_public_path__ + "static/media/dashboardLogo.1c91f81f.svg";